export function getPaginationParams(
  url: string | null,
): { limit: number; offset: number } | null {
  if (!url) {
    return null;
  }

  const urlParams = new URLSearchParams(url.split('?')[1]);
  const limit = urlParams.get('limit');
  const offset = urlParams.get('offset');

  return {
    limit: limit ? parseInt(limit, 10) : 0,
    offset: offset ? parseInt(offset, 10) : 0,
  };
}
